import { render, staticRenderFns } from "./question-wrap.vue?vue&type=template&id=9cfa6158&scoped=true&"
import script from "./question-wrap.vue?vue&type=script&lang=js&"
export * from "./question-wrap.vue?vue&type=script&lang=js&"
import style0 from "./question-wrap.vue?vue&type=style&index=0&id=9cfa6158&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cfa6158",
  null
  
)

export default component.exports